module.exports = __webpack_public_path__ + "img/left-active.e7af6b29.webp";